<template>
	<div class="brick">
		<label v-if="restriction_only_available" class="mgr_15"><input type="checkbox" v-model="restriction_only" @change="onStateReportChange" /> Restriction Only</label>
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>
				<CountrySelect v-model="country" :bool="true" />
				<state-select v-model="state" :country="country" />
				<PartnerSelect :restrictionOnly="restriction_only" v-model="ship_to_code" ph="Ship To" :showName="false" />
				<input type="checkbox" id="active" v-model="active" />
				<label for="active" class="mgr_5">Partner Active</label>
				<item-class-select-multi-s v-model="itemClasses" ref="itemClass" />

				<sales-group v-model="salesGroupCode" ref="salesGroup" :allSelect="false" />
				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt mgr_15" @click="reset()">Reset</a>
				<a href="javascript:void(0);" class="gray_bt" v-on:click="excel()">Excel</a>
			</div>
		</div>

		<table class="list_tbl" id="excelTable">
			<thead>
				<tr>
					<th width="8%">{{ headers.class }} Code</th>
					<th width="14%">{{ headers.class }} Name</th>
					<th width="4%">SG Code</th>
					<th width="7%">Sales Group Name</th>
					<th width="3%">P. Code</th>
					<th width="12%">Partner Name</th>
					<th>Address</th>
					<th width="7%">Telephone</th>
					<th width="6%">Email</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(data, index) in root" v-bind:key="index">
					<td class="al_left">
						<span v-show="index == 0 || (index > 0 && data.class_code != root[index - 1].class_code)">
							{{ data.class_code }}
						</span>
					</td>
					<td class="al_left truncate">
						<span v-show="index == 0 || (index > 0 && data.class_code != root[index - 1].class_code)">
							{{ data.class_name }}
						</span>
					</td>
					<td class="al_left">{{ data.sales_group_code }}</td>
					<td class="al_left">{{ data.sales_group_name }}</td>
					<td class="al_left">{{ data.partner_code }}</td>
					<td class="al_left">{{ data.partner_name }}</td>
					<td class="al_left">{{ data.address }}</td>
					<td class="al_left">{{ data.telephone }}</td>
					<td class="al_left">{{ data.email }}</td>
				</tr>
			</tbody>
		</table>

		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>
		<Paging ref="paging" v-on:gotoPage="search"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel()">Excel</a>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import stateReport from '@/mixins/stateReport';
import Paging from '@/components/common/Paging';
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import SalesGroup from '@/components/common/SalesGroup';
import { objectToFormData, exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';
import { apiCustomersWOItems } from '@/api/report/report';
import { today, daysAgo } from '@/utils/date';
import CountrySelect from '@/components/common/CountrySelect';
import StateSelect from '@/components/common/StateSelect';
import PartnerSelect from '@/components/common/PartnerSelect';

export default {
	mixins: [stateReport({ id: 'CustomersWOItems', search: 'search', queries: ['search'], results: ['list_count', 'root'] })],
	props: ['headers'],
	data: function() {
		return {
			itemClasses: [],
			fromDate: daysAgo(90),
			toDate: today(),
			salesGroupCode: '',
			root: [],
			group: [],
			country: '',
			state: '',
			active: true,
			ship_to_code: null,

			paging_yn: 'Y',
			// page_size: 25, // page_size는 store에 저장된 값 사용
			page_no: 1,
			list_count: 0,

			save_param: {},
		};
	},
	components: {
		CountrySelect,
		StateSelect,
		ItemClassSelectMultiS,
		CustomDatePicker,
		SalesGroup,
		Paging,
		PartnerSelect,
	},
	computed: {
		page_size() {
			return this.$store.getters['getDefaultPageSize'];
		},
	},
	methods: {
		async search(page_no) {
			if (this.itemClasses.length < 1) {
				this.$toast.error(`Item ${this.headers.class} is empty.`);
				return false;
			} else if (this.itemClasses.length > 1 && this.salesGroupCode == '' && !this.ship_to_code) {
				this.$toast.error(`Please, select sales group for multiple item ${this.headers.class}.`);
				return false;
			}

			this.save_param = {
				from_date: this.fromDate,
				to_date: this.toDate,
				sales_group_code: this.salesGroupCode,
				item_classes: this.itemClasses,
				country: this.country,
				state: this.state,
				ship_to_code: this.ship_to_code,
				active_yn: this.active ? 'Y' : 'A',
			};

			this.page_no = page_no || 1;

			const param = {
				paging_yn: this.paging_yn,
				start_index: (this.page_no - 1) * this.page_size,
				page_size: this.page_size,

				from_date: this.fromDate,
				to_date: this.toDate,
				sales_group_code: this.salesGroupCode,
				item_classes: this.itemClasses,
				country: this.country,
				state: this.state,
				ship_to_code: this.ship_to_code,
				active_yn: this.active ? 'Y' : 'A',
			};
			const data = await this.customerWOItems(param);
			this.root = data.result;
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);
		},
		async customerWOItems(param) {
			const { data } = await apiCustomersWOItems.call(this, objectToFormData(param));
			return data;
		},
		reset() {
			this.fromDate = daysAgo(90);
			this.toDate = today();
			this.$refs.itemClass.reset();
			this.$refs.salesGroup.reset();
		},
		async excel() {
			const state_output = this.captureStateReportOutput();
			if (!state_output) return;
			if (this.root.length < 1) return this.$toast.error('No Data to Export');

			const fileName = 'Customer List Without Items';
			const data = await this.customerWOItems(this.save_param);
			const headers = [
				{ key: 'class_code', name: `${this.headers.class} Code`, width: 15, dataType: defaultDataType.string },
				{ key: 'class_name', name: `${this.headers.class} Name`, width: 35, dataType: defaultDataType.string },
				{ key: 'sales_group_code', name: 'SG Code', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group Name', width: 25, dataType: defaultDataType.string },
				{ key: 'partner_code', name: 'P.Code', width: 15, dataType: defaultDataType.string },
				{ key: 'partner_name', name: 'Partner Name', width: 25, dataType: defaultDataType.string },
				{ key: 'address', name: 'Address', width: 35, dataType: defaultDataType.string },
				{ key: 'telephone', name: 'Telephone', width: 15, dataType: defaultDataType.string },
				{ key: 'email', name: 'Email', width: 25, dataType: defaultDataType.string },
			];

			if (!state_output.valid) return;

			exportDataExcel(data.result, headers, fileName);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_customer_list_with_no_certain_items');
		this.$store.commit('setSubTitle', 'Report -> Customer List Without Certain Items');
	},
};
</script>

<style scoped></style>
